import '../../../App.css';
import './Sculc-2022.css';

import ImageGallery from 'react-image-gallery'
import "react-image-gallery/styles/css/image-gallery.css";

const Sculc2022 = () => {


    const sculc2022_images = [
        {
            original: "/images/sculc2022/sculc2022-program-page-1.png",
        },
        {
            original: "/images/sculc2022/sculc2022-program-page-2.png",
        },
        {
            original: "/images/sculc2022/sculc2022-program-page-3.png",
        },
        {
            original: "/images/sculc2022/sculc2022-program-page-4.png",
        }
    ];

    return (
        <div className="sculc2022-page">
            <div className="sculc2022-header-container">
                <img
                    src="/images/sculc-banner.jpg"
                    alt="Header"
                    className="sculc2022-header-image"
                />  
                <h1 className="sculc2022-title">SCULC 2022</h1>
            </div>
            <div className="sculc2022-navbar">
                <div className="sculc2022-navbar-container">
                    <a href="/sculc-2022" className="sculc2022-links">Home</a>
                    <a href="/sculc-2022-program" className="sculc2022-links">Programs</a>
                    <a href="/sculc-2022-presentation" className="sculc2022-links">Presentations</a>
                    <a href="/sculc-2022-photo" className="sculc2022-links">Photos</a>
                </div>
            </div>
            <div className="sculc2022-banner">
                <p style={{ fontSize: "1.5em", }}>SCULC 2022 has concluded!</p>
                <br></br>
                <a href="/sculc-2023" className="sculc2022-links" style={{ color:"#4499cc"} }>Check out SCULC 2023</a>
            </div>
            <p style={{marginLeft: "10%", marginRight: "10%"}}>
                <i><strong>Please see the above Home / Program / Presentations / Photos tabs to view past conference presentations, program details, and photos from the conference.</strong></i>
            </p>
            <div className="sculc2022-container">
                <div className="sculc2022-table-container">
                    <div className="sculc2022-logo-container">
                        <img src="/images/sculc-logo.png" 
                            alt="Sculc-logo"
                            className="sculc2022-logos"></img>
                        <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTp54YxRQRb-RP_hB76IsDNqaje6X6QhlyRQA&s"
                            alt="dept-of-ling"
                        className="sculc2022-logos"></img>
                        <img src="/images/bruin-linguists-logo.png"
                            alt="club-logo"
                        className="sculc2022-logos"></img>
                    </div>
                    <div className="sculc2022-table-cells">
                        <p style={{ fontSize: "1.8em", color: "#2774ae" }}>Southern California Undergraduate Linguistics Conference</p>
                        <br></br>
                        <p style={{ fontSize: "1.3em"}}>Saturday, 21 May 2022, 09:00 AM - 05:00 PM</p>

                        <br></br>
                        <p style={{ fontSize: "1.3em" }}>UCLA's Campbell Hall Learning Pavilion</p>
                        <br></br>
                        <p style={{ fontSize: "1.2em", textAlign: "left", lineHeight: "1.5em" }}><strong>SCULC</strong> (the Southern California Undergraduate Linguistics Conference) will be held again in May 2022
                            by the University of California, Los Angeles Linguistics Department and the undergraduate-run
                            linguistics society, Bruin Linguists Society. Founded in 2010 by Bruin Linguists, SCULC was
                            established to create a collaborative and educational environment for the undergraduate linguistics
                            community. Throughout the years, it has been entirely student-run and free for all participants,
                            presenters, and guests, supported by contributions from the linguistics community, the UCLA
                            Linguistics Department, and individuals working to help enhance and expand the experience of
                            undergraduates in linguistics. </p>
                        <br></br>
                        <p style={{ fontSize: "1.2em", textAlign: "left", lineHeight: "1.5em" }}>To sign up for updates, please join the mailing list: <a href="https://forms.gle/RBYcfiyJ4oJM2My1A">forms.gle/RBYcfiyJ4oJM2My1A</a> </p>
                        <br></br>
                        <p><i>Sponsored by the UCLA Department of Linguistics and the Bruin Linguists Society</i></p>
                        <div style={{ height: "5em"} }></div>

                        <p style={{ fontSize: "1.8em", color: "#2774ae" }}>Our Call for Abstracts has closed</p>
                    </div>
                </div>
                <div className="sculc2022-table-container">
                    <div className="sculc2022-schedule-container">
                        <ImageGallery items={sculc2022_images} showThumbnails={false} showPlayButton={false} width="100%"/>
                    </div>

                    <div className="sculc2022-table-cells" style={{ textAlign: "left", fontSize: "1.2em", flex:"1 1 40%" }}>
                        <p>Please <strong>view our Program</strong> through the Image Carousel on the Left or download  our program on our Program page.
                        </p><br></br>
                        <p><u>All conference attendees must fill out the following RSVP form.</u> This can be done prior to arriving or upon arrival at the check-in desk.
                        </p><br></br>
                        <p><strong>RSVP form: </strong><a href="https://tinyurl.com/sculc2022">https://tinyurl.com/sculc2022</a></p>
                        <br></br>
                        <p><u>All conferences attendees must also fill out the following  UCLA Daily Symptom Monitoring Survey </u><strong>on the day of the conference:</strong>
                            <div style={{ wordBreak: "break-all" }}><a href="https://uclasurveys.co1.qualtrics.com/jfe/form/SV_3qRLtouCYKzBbH7">https://uclasurveys.co1.qualtrics.com/jfe/form/SV_3qRLtouCYKzBbH7</a> </div></p><br></br>
                        <p><strong>UCLA COVID-19 Guidelines:</strong></p>
                        <p>Face masks: Masking at indoor events is not required — but is strongly recommended — for individuals who are up to date on their vaccinations (including boosters). Those who are not up to date on vaccinations — including those who have received exceptions to the UC vaccination policy — are still required to wear well-fitting masks at all indoor events.  For the most up to date information, visit <a href="https://covid-19.ucla.edu/guidance-for-events-and-performances/">https://covid-19.ucla.edu/guidance-for-events-and-performances/ </a> </p>
                    </div>
                </div>
                <div className="sculc2022-table-container">
                <div className="sculc2022-table-cells">
                    <div style={{width: "100%", textAlign: "left", fontSize: "1.2em", marginTop: "1em"} }>
                            <p style={{ fontSize: "2em", color: "#2774ae" }}>PRESENTERS</p><br></br>
                    <p>SCULC is looking for undergraduate presenters from any university to submit their research for presentation. Undergraduate students at all levels are encouraged to submit abstracts for 10-15 minute oral presentations
                                or for a poster session. Students who have recently graduated but have not yet entered a graduate program are welcome to submit abstracts. You can submit abstracts for both oral and poster presentations but they must be on different research projects. <strong>Please note that we also welcome submissions on research that is still in progress.</strong></p>
                    <br></br>
                        <p>We also invite graduate students, lecturers, and other researchers to submit proposals for keynote talks. Please email us at bruinlinguists@gmail.com before submitting your keynote abstract to our Call for Abstracts.</p><br></br>
                            <p><strong>Call For Abstracts Link:</strong></p>
                            <p><a href="https://easychair.org/cfp/SCULC2022">easychair.org/cfp/SCULC2022 </a></p><br></br>
                            <p><strong>Abstract Submission Guidelines: </strong></p>
                        <ul>
                            <li>Please submit an abstract for your research work via easychair by March 26, 2022 11:59 PM PST.</li>
                            <li>Research from all subfields of linguistics, in both applied and theoretical work, are welcome.  Research in progress is fine too.</li>
                            <li>The abstract should be no more than 500 words, not including references.</li>
                            <li>Please make sure the abstract is in a PDF format and that there is no identification of yourself in the abstract (anonymized submission). </li>
                            <li>If you are submitting something as part of work on a greater research project with a team or a professor, be prepared to submit verification from the PI that they are aware you are submitting this work if your abstract is accepted.</li>
                        </ul>
                        <p>Abstracts that do not follow these guidelines will not be considered. Accepted submissions will be announced in early May. Please keep in mind that these abstracts and potential presentations will not be published. Travel expenses are the responsibility of the presenter.</p><br></br>
                        <p>If you have any questions or concerns, please don't hesitate to contact the organizers at bruinlinguists@gmail.com. Be sure to specify in the subject line that your correspondence is related to SCULC 2022. We look forward to seeing all of your presentations this May!</p><br></br>
                    </div>
                    </div>
                </div>
            </div>

                
        </div>
    );
};

export default Sculc2022;
